// extracted by mini-css-extract-plugin
module.exports = {"root":"Stepper_root__20PUE","step":"Stepper_step__3ZXcZ","active":"Stepper_active__2dm9x"};